import type { ReactElement } from 'react';

import { HeaderLinkButton } from '@repo/ui/fixtures/header/components/HeaderLinkButton/HeaderLinkButton';
import type { LinkButton } from '@repo/ui/fixtures/header/types/menu-items';

import './HeaderDesktopMenu.scss';

interface HeaderDesktopMenuProps {
  navLinks: LinkButton[];
  preNavLinkContent?: ReactElement;
  postNavLinkContent?: ReactElement;
}

export function HeaderDesktopMenu({ navLinks, preNavLinkContent, postNavLinkContent }: HeaderDesktopMenuProps) {
  return (
    <div className="HeaderDesktopMenu">
      {preNavLinkContent}
      <nav className="HeaderDesktopMenu__nav">
        <ul className="HeaderDesktopMenu__list">
          {navLinks.map(link => (
            <HeaderLinkButton
              key={link.text}
              text={link.text}
              href={link.href}
              subMenuItems={link.subMenuItems}
              icon={link.icon}
              dataTestId={link.dataTestId}
            />
          ))}
        </ul>
      </nav>
      {postNavLinkContent}
    </div>
  );
}
